var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckpositive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    viewBox: "0 0 288 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C11.1929 0 0 11.1929 0 25V263C0 276.807 11.1929 288 25 288H263C276.807 288 288 276.807 288 263V25C288 11.1929 276.807 0 263 0H25ZM225.396 60.729L102.479 183.646L62.8958 144.062C59.0764 140.243 54.2153 138.333 48.3125 138.333C42.4097 138.333 37.5486 140.243 33.7292 144.062C29.9097 147.882 28 152.743 28 158.646C28 164.549 29.9097 169.41 33.7292 173.229L87.8958 227.396C92.0625 231.562 96.9236 233.646 102.479 233.646C108.035 233.646 112.896 231.562 117.062 227.396L254.562 89.896C258.382 86.0762 260.292 81.2153 260.292 75.3125C260.292 69.4097 258.382 64.5488 254.562 60.729C250.743 56.9097 245.882 55 239.979 55C234.076 55 229.215 56.9097 225.396 60.729Z",
    fill: "#18A748"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckpositive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkpositive.fa5fdc2f8acdb82993b2ef1ff700357e.svg";